import React, { Component } from 'react';
// import { connect } from 'react-redux';
import ContainerDivided from 'screens/components/basic/ContainerDivided';
import LOOKUP from 'constants/lookup';
import { Link } from 'react-router-dom';
import GenericTable from 'screens/components/advanced/GenericTable';
import Button from 'screens/components/basic/Button';
import Panel from 'screens/components/basic/Panel';
import WithRouter from 'custom/withRouter';

class CouponList extends Component {
    constructor(props) {
        super(props);
        this.getCoupons = this.getCoupons.bind(this);
    }

    editCoupon = () => {
        this.props.navigate('/admin/coupon/edit');
    }

    redirectToAddPage = () => {
        this.props.navigate('/admin/coupon/edit');
    }

    getCoupons = () => {
        return (
            [
                {
                    couponName: "10% OFF",
                    couponDate: "2017-12-11 ~ 2017-12-16",
                    couponStatus: "Active",
                    couponEdit: (
                        <div>
                            <Button
                                type="EditButton"
                                label="Edit"
                                primary={true}
                                onTouchTap={() => this.editCoupon()}
                            />
                        </div>
                    )
                },
                {
                    couponName: "$2.00 OFF",
                    couponDate: "2017-11-12 ~ 2017-11-15",
                    couponStatus: "Active",
                    couponEdit: (
                        <div>
                            <Button
                                type="EditButton"
                                label="Edit"
                                primary={true}
                                onTouchTap={() => this.editCoupon()}
                            />
                        </div>
                    )
                }
            ]
        );
    }

    render() {
        // const p = this.props;
        // const s = this.state;
        const header = (
            <div>
                <ol className="breadcrumb">
                    <li><Link to={LOOKUP.menu.home.link}>{LOOKUP.menu.home.text}</Link></li>
                    <li className="active"><Link to={LOOKUP.menu.admin.coupon.link}>{LOOKUP.menu.admin.coupon.text}</Link></li>
                </ol>
                <h2>{LOOKUP.menu.admin.coupon.text}</h2>
            </div>
        );

        const sideContent = (
            <Panel title="Toolbox">
                <div className="row text-center">
                    <Button type="AddButton"
                        className="toolbox-button"
                        label={LOOKUP.menu.admin.coupon.controls.addNewButton}
                        onTouchTap={this.props.redirectToAddPage} />
                </div>
            </Panel>
        );

        return (
            <ContainerDivided headerContent={header} sideContent={sideContent}>
                <GenericTable
                    className="table_center"
                    compName="cashRegistersListTable"
                    tableBodyClassName="table_center"
                    multiSelectable={true}
                    enableSelectAll={false}
                    displaySelectAll={false}
                    adjustForCheckbox={false}
                    displayRowCheckbox={false}
                    selectable={true}
                    columns={LOOKUP.menu.admin.coupon.tableColumns}
                    rows={this.getCoupons()}
                    stripedRows={true}
                />
            </ContainerDivided>
        );
    }
}

export default WithRouter(CouponList);